<template>
  <TeaserCards
    :items="teaserCards"
    grid-type="masonry"
    :header-gutter="false"
    :max-columns="3"
    link-icon-position="content"
  />
</template>

<script lang="ts" setup>
import { TeaserCards } from '@hypercodestudio/basler-components';
import type { Props as TeaserCardProps } from '@hypercodestudio/basler-components/dist/components/modules/TeaserCard.vue';
import { isDefined } from '~/utils/guards/isDefined';
import type { AlgoliaContentfulPage } from '~/lib/AlgoliaService/models/AlgoliaContentfulPage';
import type { AlgoliaProduct } from '~/lib/AlgoliaService/models/AlgoliaProduct';
import { transformSearchResultToTeaserCard } from '~/utils/transformSearchResultToTeaserCard';
import type { SearchTagModel } from '~/utils/createDictKeysForSearchTags';
import type { DownloadEntryModel } from '~/lib/DownloadService/model';

type Props = {
  results: (AlgoliaContentfulPage | AlgoliaProduct | DownloadEntryModel)[];
  allowedTags: SearchTagModel[];
};

const props = defineProps<Props>();

const { $resolvedLocale } = useNuxtApp();
const route = useRoute();

const teaserCards = computed<TeaserCardProps[]>(() => {
  return props.results
    .map((result) =>
      transformSearchResultToTeaserCard(
        result,
        props.allowedTags,
        $resolvedLocale.value!,
        route.query
      )
    )
    .filter(isDefined);
});
</script>
